import React from 'react';
import { Link } from 'react-router-dom';

const F = { fontFamily: "'Barlow', sans-serif" };

function Termos() {
  return (
    <div style={{ background: '#0a0a0a', minHeight: '100vh', ...F }}>
      {/* Neon line */}
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 1, background: 'linear-gradient(90deg, transparent 0%, #00E633 30%, #009BFF 70%, transparent 100%)', zIndex: 9999 }} />

      {/* Header */}
      <div style={{ background: '#000', borderBottom: '1px solid rgba(255,255,255,0.05)', padding: '16px 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Link to="/">
          <img src={require('../logo.png')} alt="PokerMind Brasil" style={{ height: 36, objectFit: 'contain' }} />
        </Link>
        <Link to="/" style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, fontWeight: 500, textDecoration: 'none', transition: 'color 0.2s', ...F }}
          onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.8)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.4)'}>
          ← Voltar
        </Link>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '64px 24px 100px' }}>
        {/* Doc header */}
        <div style={{ borderBottom: '1px solid rgba(255,255,255,0.06)', paddingBottom: 32, marginBottom: 40 }}>
          <div style={{ display: 'inline-block', background: 'rgba(0,230,51,0.08)', border: '1px solid rgba(0,230,51,0.2)', color: '#00E633', fontSize: 10, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', padding: '4px 12px', borderRadius: 20, marginBottom: 20, ...F }}>Documento Legal</div>
          <h1 style={{ fontSize: 48, fontWeight: 900, textTransform: 'uppercase', letterSpacing: -1, lineHeight: 0.95, color: '#fff', marginBottom: 12, ...F }}>Termos de Uso</h1>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.3)', ...F }}>Última atualização: março de 2026 · PokerMind Brasil</div>
        </div>

        {/* Intro */}
        <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, marginBottom: 40, ...F }}>
          Ao criar uma conta no PokerMind Brasil, você concorda com estes Termos de Uso. Leia com atenção antes de utilizar a plataforma.
        </p>

        {/* Sections */}
        <style>{`
          .tm-h2 { font-size:16px; font-weight:800; color:#fff; text-transform:uppercase; letter-spacing:0.5px; margin-top:40px; margin-bottom:14px; padding-left:14px; border-left:3px solid #00E633; font-family:'Barlow',sans-serif; }
          .tm-h2:not(:first-of-type) { padding-top:40px; border-top:1px solid rgba(255,255,255,0.04); }
          .tm-p { font-size:14px; color:rgba(255,255,255,0.55); line-height:1.8; margin-bottom:12px; font-family:'Barlow',sans-serif; }
          .tm-ul { margin-left:20px; margin-bottom:12px; }
          .tm-li { font-size:14px; color:rgba(255,255,255,0.5); line-height:1.7; margin-bottom:6px; font-family:'Barlow',sans-serif; }
          .tm-li::marker { color:#00E633; }
          .tm-a { color:#00E633; text-decoration:none; }
          .tm-a:hover { opacity:0.8; }
        `}</style>

        <h2 className="tm-h2">1. Sobre o PokerMind Brasil</h2>
        <p className="tm-p">O PokerMind Brasil é uma plataforma de educação e treinamento de poker online, que oferece ferramentas de análise de mãos, Coach IA conversacional, planos de estudo personalizados e conteúdo educacional. A plataforma é operada por PokerMind Brasil e acessível exclusivamente via navegador web.</p>

        <h2 className="tm-h2">2. Elegibilidade</h2>
        <p className="tm-p">Para utilizar o PokerMind Brasil, você deve:</p>
        <ul className="tm-ul">
          <li className="tm-li">Ter no mínimo 18 anos de idade;</li>
          <li className="tm-li">Possuir capacidade legal para celebrar contratos;</li>
          <li className="tm-li">Não estar proibido de utilizar serviços similares por lei ou regulamentação aplicável;</li>
          <li className="tm-li">Fornecer informações verdadeiras no cadastro.</li>
        </ul>

        <h2 className="tm-h2">3. Conta e Responsabilidades do Usuário</h2>
        <p className="tm-p">Ao criar uma conta, você é responsável por:</p>
        <ul className="tm-ul">
          <li className="tm-li">Manter a confidencialidade da sua senha e dados de acesso;</li>
          <li className="tm-li">Todas as atividades realizadas na sua conta;</li>
          <li className="tm-li">Notificar imediatamente o PokerMind Brasil em caso de uso não autorizado da sua conta;</li>
          <li className="tm-li">Fornecer informações precisas e atualizadas.</li>
        </ul>
        <p className="tm-p">É proibido compartilhar o acesso à sua conta com terceiros. Contas com suspeita de compartilhamento poderão ser suspensas.</p>

        <h2 className="tm-h2">4. Planos e Pagamentos</h2>
        <p className="tm-p">O PokerMind Brasil oferece planos gratuitos e pagos. Os planos pagos são cobrados de forma recorrente (mensal ou anual) através da plataforma Kiwify.</p>
        <ul className="tm-ul">
          <li className="tm-li"><strong>Plano Free:</strong> gratuito, com recursos limitados conforme descrito na página de planos;</li>
          <li className="tm-li"><strong>Plano Pro:</strong> assinatura recorrente com acesso expandido;</li>
          <li className="tm-li"><strong>Plano Elite:</strong> assinatura recorrente com acesso completo.</li>
        </ul>
        <p className="tm-p">Os preços são exibidos em reais (BRL) e podem ser alterados com aviso prévio de 30 dias. O cancelamento pode ser feito a qualquer momento, sem multa, com acesso mantido até o fim do período pago.</p>

        <h2 className="tm-h2">5. Teste Grátis</h2>
        <p className="tm-p">O Plano Pro oferece período de teste gratuito de 7 dias sem necessidade de cartão de crédito. Ao final do período, o plano é automaticamente cancelado caso não haja contratação ativa.</p>

        <h2 className="tm-h2">6. Propriedade Intelectual</h2>
        <p className="tm-p">Todo o conteúdo da plataforma — incluindo textos, vídeos, aulas, código, interface e marca PokerMind Brasil — é de propriedade exclusiva da empresa. É proibido reproduzir, distribuir ou criar obras derivadas sem autorização prévia por escrito.</p>
        <p className="tm-p">O conteúdo gerado pelo Coach IA é produzido para uso pessoal do usuário e não pode ser redistribuído comercialmente.</p>

        <h2 className="tm-h2">7. Uso Aceitável</h2>
        <p className="tm-p">É proibido utilizar o PokerMind Brasil para:</p>
        <ul className="tm-ul">
          <li className="tm-li">Violar leis ou regulamentações aplicáveis;</li>
          <li className="tm-li">Realizar engenharia reversa, scraping ou extração automatizada de dados;</li>
          <li className="tm-li">Usar o Coach IA como assistência em tempo real (RTA) durante partidas online;</li>
          <li className="tm-li">Tentar comprometer a segurança ou integridade da plataforma;</li>
          <li className="tm-li">Criar múltiplas contas para burlar limitações do plano gratuito.</li>
        </ul>

        <h2 className="tm-h2">8. Limitação de Responsabilidade</h2>
        <p className="tm-p">O PokerMind Brasil é uma ferramenta educacional. Não garantimos resultados financeiros decorrentes do uso da plataforma. O usuário é inteiramente responsável pelas suas decisões de jogo e gestão financeira.</p>
        <p className="tm-p">A plataforma é fornecida "como está", sem garantias de disponibilidade ininterrupta. Não nos responsabilizamos por perdas decorrentes de interrupções técnicas.</p>

        <h2 className="tm-h2">9. Cancelamento e Encerramento</h2>
        <p className="tm-p">Você pode cancelar sua assinatura a qualquer momento pelo painel de controle da Kiwify. O PokerMind Brasil reserva-se o direito de suspender ou encerrar contas que violem estes Termos de Uso, sem reembolso.</p>

        <h2 className="tm-h2">10. Alterações nos Termos</h2>
        <p className="tm-p">Podemos atualizar estes Termos periodicamente. Alterações relevantes serão comunicadas por e-mail com antecedência mínima de 15 dias. O uso continuado da plataforma após as alterações implica aceitação dos novos termos.</p>

        <h2 className="tm-h2">11. Contato</h2>
        <p className="tm-p">Para dúvidas sobre estes Termos, entre em contato pelo e-mail <a className="tm-a" href="mailto:contato@pokermindbrasil.com">contato@pokermindbrasil.com</a>.</p>
      </div>

      {/* Footer */}
      <footer style={{ background: '#000', borderTop: '1px solid rgba(255,255,255,0.05)', padding: '24px 48px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: 12, ...F }}>© 2026 PokerMind Brasil</span>
        <Link to="/" style={{ color: '#00E633', fontSize: 12, fontWeight: 600, textDecoration: 'none', ...F }}>← Voltar ao site</Link>
      </footer>
    </div>
  );
}

export default Termos;
